import { openChatPane, type OpenChatPaneOptions } from './openChatPane';
import { openAgentChatPane } from './openAgentChatPane';
import type { AgentType, OpenBizChatSidePaneParams } from 'owa-bizchat-types';
import { isNonExecutableCmmId } from './isNonExecutableCmmId';
import type { MailboxInfo } from 'owa-client-types';

/**
 * Specific variation of `openChatPane` that always executes the prompt.
 */
export const executePrompt = (
    promptText: OpenChatPaneOptions['promptText'],
    // Also known as "CMM ID"
    formCode: OpenBizChatSidePaneParams['formCode'],
    targetWindow: Window,
    mailboxInfo: MailboxInfo,
    agentType?: AgentType
): void => {
    const shouldExecuteQuery = !isNonExecutableCmmId(formCode);

    if (agentType) {
        openAgentChatPane({
            promptText,
            targetWindow,
            agentType,
            shouldExecuteQuery,
            formCode,
            mailboxInfo,
        });
        return;
    }

    openChatPane({
        params: {
            formCode,
            shouldExecuteQuery,
        },
        promptText,
        targetWindow,
        mailboxInfo,
    });
};
